import React from 'react'
import { Modal } from 'hljd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { isNewOpen } from '@util'

export default (store, data) => {
  const { isSingle } = store
  const title = isSingle ? '单品' : '套餐'

  let info = {
    title: `${title}编辑成功，等待审核结果`,
    width: 500,
    content: (
      <div style={{ width: '375px' }}>
        <p style={{ color: '#666', lineHeight: '22px', marginTop: '4px' }}>
          {data.tips}
        </p>
        <img
          style={{
            width: '135px',
            margin: '32px auto 0 auto',
            display: 'block'
          }}
          src={
            data.serviceQrcode ||
            data.service_qrcode ||
            'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQH_7zwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyUk94WHNFSVpjOTAxc0wxSGh1MWQAAgSvb2peAwSAUQEA&expire_seconds=86400'
          }
        />
        <p style={{ color: '#666', marginTop: '14px', textAlign: 'center' }}>
          微信扫码查看审核结果
        </p>
      </div>
    ),
    onOk: () => {
      window.location.href = store.getUrl()
    }
  }

  isNewOpen()
    ? Modal.confirm({
        icon: (
          <CheckCircleOutlined style={{ color: '#2FC286', fontSize: 20 }} />
        ),
        ...info,
        okText: '立即查看',
        cancelText: '继续其他开店任务',
        onCancel: () => {
          window.location.href = '#/localMerchant/home'
        }
      })
    : Modal.success({
        ...info
      })
}
